// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    ProviderPayerSubscriber,
    ProviderPayerSubscriberSortType,
    SupportCreatePayerSubscriberPayload,
    SupportPayerSubscriber,
    SupportPayerSubscriberSortType,
    SupportReplacePayerSubscriberPayload,
    SupportUpdatePayerSubscriberPayload,
    SupportCreatePayerSubscriberPayloadToJSON,
    SupportReplacePayerSubscriberPayloadToJSON,
    SupportUpdatePayerSubscriberPayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderPayerSubscriberFromJSON,
    SupportPayerSubscriberFromJSON,
} from '../models';

export interface CreateSupportPayerSubscriberRequest {
    supportCreatePayerSubscriberPayload: SupportCreatePayerSubscriberPayload;
}

export interface DisableSupportPayerSubscriberRequest {
    id: string;
}

export interface GetProviderPayerSubscriberRequest {
    id: string;
}

export interface GetSupportPayerSubscriberRequest {
    id: string;
}

export interface ListProviderPayerSubscribersRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderPayerSubscribersOrderEnum>;
    filterCreated?: Array<string>;
    filterMemberId?: Array<string>;
    filterGroupId?: Array<string>;
    filterGroupName?: Array<string>;
    filterPlanName?: Array<string>;
    filterPlanId?: Array<string>;
    filterPayerId?: Array<string>;
    filterSubscriberId?: Array<string>;
    filterFirstLast?: Array<string>;
    sort?: Array<ProviderPayerSubscriberSortType>;
}

export interface ListSupportPayerSubscribersRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportPayerSubscribersOrderEnum>;
    filterStarred?: string;
    filterCreated?: Array<string>;
    filterActive?: string;
    filterMemberId?: Array<string>;
    filterGroupId?: Array<string>;
    filterGroupName?: Array<string>;
    filterPlanName?: Array<string>;
    filterPlanId?: Array<string>;
    filterPayerId?: Array<string>;
    filterSubscriberId?: Array<string>;
    filterFirstLast?: Array<string>;
    sort?: Array<SupportPayerSubscriberSortType>;
}

export interface ReplaceSupportPayerSubscriberRequest {
    supportReplacePayerSubscriberPayload: SupportReplacePayerSubscriberPayload;
}

export interface UpdateSupportPayerSubscriberRequest {
    id: string;
    supportUpdatePayerSubscriberPayload: SupportUpdatePayerSubscriberPayload;
}

/**
 * no description
 */
export class PayerSubscriberApi extends runtime.BaseAPI {

    /**
     * Create a payer subscriber
     * Create a payer subscriber
     */
    async createSupportPayerSubscriberRaw(requestParameters: CreateSupportPayerSubscriberRequest): Promise<runtime.ApiResponse<SupportPayerSubscriber>> {
        if (requestParameters['supportCreatePayerSubscriberPayload'] === null || requestParameters['supportCreatePayerSubscriberPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreatePayerSubscriberPayload','Required parameter requestParameters.supportCreatePayerSubscriberPayload was null or undefined when calling createSupportPayerSubscriber.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:payersubscriber", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payersubscriber`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreatePayerSubscriberPayloadToJSON(requestParameters['supportCreatePayerSubscriberPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportPayerSubscriberFromJSON(jsonValue));
    }

    /**
     * Create a payer subscriber
     * Create a payer subscriber
     */
    async createSupportPayerSubscriber(requestParameters: CreateSupportPayerSubscriberRequest): Promise<SupportPayerSubscriber> {
        const response = await this.createSupportPayerSubscriberRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a payer subscriber
     * Disable a payer subscriber
     */
    async disableSupportPayerSubscriberRaw(requestParameters: DisableSupportPayerSubscriberRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportPayerSubscriber.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:payersubscriber", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payersubscriber/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a payer subscriber
     * Disable a payer subscriber
     */
    async disableSupportPayerSubscriber(requestParameters: DisableSupportPayerSubscriberRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportPayerSubscriberRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a payer subscriber
     * Get a payer subscriber
     */
    async getProviderPayerSubscriberRaw(requestParameters: GetProviderPayerSubscriberRequest): Promise<runtime.ApiResponse<ProviderPayerSubscriber>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderPayerSubscriber.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payersubscriber"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/payersubscriber/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderPayerSubscriberFromJSON(jsonValue));
    }

    /**
     * Gets a payer subscriber
     * Get a payer subscriber
     */
    async getProviderPayerSubscriber(requestParameters: GetProviderPayerSubscriberRequest): Promise<ProviderPayerSubscriber> {
        const response = await this.getProviderPayerSubscriberRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a payer subscriber
     * Get a payer subscriber
     */
    async getSupportPayerSubscriberRaw(requestParameters: GetSupportPayerSubscriberRequest): Promise<runtime.ApiResponse<SupportPayerSubscriber>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportPayerSubscriber.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payersubscriber", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payersubscriber/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportPayerSubscriberFromJSON(jsonValue));
    }

    /**
     * Gets a payer subscriber
     * Get a payer subscriber
     */
    async getSupportPayerSubscriber(requestParameters: GetSupportPayerSubscriberRequest): Promise<SupportPayerSubscriber> {
        const response = await this.getSupportPayerSubscriberRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of payer subscribers
     * Get a list of payer subscribers
     */
    async listProviderPayerSubscribersRaw(requestParameters: ListProviderPayerSubscribersRequest): Promise<runtime.ApiResponse<Array<ProviderPayerSubscriber>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterMemberId) {
            queryParameters['filterMemberId'] = requestParameters.filterMemberId;
        }

        if (requestParameters.filterGroupId) {
            queryParameters['filterGroupId'] = requestParameters.filterGroupId;
        }

        if (requestParameters.filterGroupName) {
            queryParameters['filterGroupName'] = requestParameters.filterGroupName;
        }

        if (requestParameters.filterPlanName) {
            queryParameters['filterPlanName'] = requestParameters.filterPlanName;
        }

        if (requestParameters.filterPlanId) {
            queryParameters['filterPlanId'] = requestParameters.filterPlanId;
        }

        if (requestParameters.filterPayerId) {
            queryParameters['filterPayerId'] = requestParameters.filterPayerId;
        }

        if (requestParameters.filterSubscriberId) {
            queryParameters['filterSubscriberId'] = requestParameters.filterSubscriberId;
        }

        if (requestParameters.filterFirstLast) {
            queryParameters['filterFirstLast'] = requestParameters.filterFirstLast;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payersubscriber"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/payersubscriber`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderPayerSubscriberFromJSON));
    }

    /**
     * Gets a list of payer subscribers
     * Get a list of payer subscribers
     */
    async listProviderPayerSubscribers(requestParameters: ListProviderPayerSubscribersRequest): Promise<Array<ProviderPayerSubscriber>> {
        const response = await this.listProviderPayerSubscribersRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of payer subscribers
     * Get a list of payer subscribers
     */
    async listSupportPayerSubscribersRaw(requestParameters: ListSupportPayerSubscribersRequest): Promise<runtime.ApiResponse<Array<SupportPayerSubscriber>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterMemberId) {
            queryParameters['filterMemberId'] = requestParameters.filterMemberId;
        }

        if (requestParameters.filterGroupId) {
            queryParameters['filterGroupId'] = requestParameters.filterGroupId;
        }

        if (requestParameters.filterGroupName) {
            queryParameters['filterGroupName'] = requestParameters.filterGroupName;
        }

        if (requestParameters.filterPlanName) {
            queryParameters['filterPlanName'] = requestParameters.filterPlanName;
        }

        if (requestParameters.filterPlanId) {
            queryParameters['filterPlanId'] = requestParameters.filterPlanId;
        }

        if (requestParameters.filterPayerId) {
            queryParameters['filterPayerId'] = requestParameters.filterPayerId;
        }

        if (requestParameters.filterSubscriberId) {
            queryParameters['filterSubscriberId'] = requestParameters.filterSubscriberId;
        }

        if (requestParameters.filterFirstLast) {
            queryParameters['filterFirstLast'] = requestParameters.filterFirstLast;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payersubscriber", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payersubscriber`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportPayerSubscriberFromJSON));
    }

    /**
     * Gets a list of payer subscribers
     * Get a list of payer subscribers
     */
    async listSupportPayerSubscribers(requestParameters: ListSupportPayerSubscribersRequest): Promise<Array<SupportPayerSubscriber>> {
        const response = await this.listSupportPayerSubscribersRaw(requestParameters);
        return await response.value();
    }

    /**
     * Replace a payer subscriber
     * Replace a payer subscriber
     */
    async replaceSupportPayerSubscriberRaw(requestParameters: ReplaceSupportPayerSubscriberRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['supportReplacePayerSubscriberPayload'] === null || requestParameters['supportReplacePayerSubscriberPayload'] === undefined) {
            throw new runtime.RequiredError('supportReplacePayerSubscriberPayload','Required parameter requestParameters.supportReplacePayerSubscriberPayload was null or undefined when calling replaceSupportPayerSubscriber.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payersubscriber", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payersubscriber/replace`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportReplacePayerSubscriberPayloadToJSON(requestParameters['supportReplacePayerSubscriberPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Replace a payer subscriber
     * Replace a payer subscriber
     */
    async replaceSupportPayerSubscriber(requestParameters: ReplaceSupportPayerSubscriberRequest): Promise<ObjectNoResponse> {
        const response = await this.replaceSupportPayerSubscriberRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a payer subscriber
     * Update a payer subscriber
     */
    async updateSupportPayerSubscriberRaw(requestParameters: UpdateSupportPayerSubscriberRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupportPayerSubscriber.');
        }

        if (requestParameters['supportUpdatePayerSubscriberPayload'] === null || requestParameters['supportUpdatePayerSubscriberPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdatePayerSubscriberPayload','Required parameter requestParameters.supportUpdatePayerSubscriberPayload was null or undefined when calling updateSupportPayerSubscriber.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payer", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payersubscriber/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdatePayerSubscriberPayloadToJSON(requestParameters['supportUpdatePayerSubscriberPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a payer subscriber
     * Update a payer subscriber
     */
    async updateSupportPayerSubscriber(requestParameters: UpdateSupportPayerSubscriberRequest): Promise<ObjectNoResponse> {
        const response = await this.updateSupportPayerSubscriberRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderPayerSubscribersOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportPayerSubscribersOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
